<div class="container my-5 p-4 login-container shadow rounded-4 bg-white" style="max-width: 500px">
  <h3 class="text-center mb-4">{{ "Dashboard Login" | translate }}</h3>

  <div class="mb-3">
    <label class="form-label">{{ "Email" | translate }}</label>
    <input [(ngModel)]="email" type="text" class="form-control" />
  </div>

  <div class="mb-3">
    <label class="form-label">{{ "Password" | translate }}</label>
    <input [(ngModel)]="password" type="password" class="form-control" />
  </div>

  <div class="text-danger mb-2" *ngIf="error">{{ error }}</div>

  <button class="btn btn-primary w-100" (click)="login()">{{ "Login" | translate }}</button>
</div>
